module.exports = __webpack_public_path__ + "img/paymentMockup.7ec1452e.png";